import { useSelector } from "react-redux";
import { X, Check } from "lucide-react";
import NoDataDisplay from "../../../components/UI/NoDataDisplay";
import { checkValue } from "../../../functions/checkValue";
import { DEACTIVATED_SITES_HEADERS } from "../utils/siteTables.config";
import { DEACTIVATED_SITES_SEARCH } from "../utils/siteFilter.config";
import SearchTable from "../../../components/common/SearchTable";
import sortDataByNumber from "../../../functions/sorting/sortDataByNumber";
import { formatDeactivatedSitesExcelData } from "../utils/excelFormatters";
import ExportButton from "../../../components/exportExcel/ExportButton";

export const DeactivatedSitesContainer = () => {
  const usersData = useSelector((state) => state.data.data);
  const originalSitesData = useSelector((state) => state.data.copyData);
  const sortedSites = sortDataByNumber(usersData, "id");
  const sortedOriginalData = sortDataByNumber(originalSitesData, "id");

  // ...............get  excel data............
  const excelData = formatDeactivatedSitesExcelData(sortedOriginalData);
  const excelConfig = {
    data: excelData,
    fileName: "Deactivated_Sites_Data",
    sheetName: "Deactivated Sites",
  };

  return (
    <div className="flex gap-2 my-3 h-[calc(100vh-5em)] max-lg:h-[calc(100vh-4em)] max-md:h-[calc(100vh-5em)] flex-col">
      <div className="flex justify-between gap-2">
        <SearchTable
          width="flex-1"
          searchCategories={DEACTIVATED_SITES_SEARCH}
          placeholder="Search by Site ID/Name or Machine ID"
        />
        <ExportButton excelConfig={excelConfig} />
      </div>
      <div className="bg-white p-3 rounded-lg h-full relative">
        <div className="max-h-[680px] max-lg:h-[530px] max-md:h-[450px] overflow-scroll">
          <table className="w-full border-collapse text-center max-lg:text-xs">
            <thead className="sticky top-0">
              <tr className="bg-dBlue-100 uppercase tracking-wide rounded-full text-dark-blue [&_th]:py-2 [&_th]:px-3">
                {DEACTIVATED_SITES_HEADERS.map(({ label, className = "" }) => (
                  <th key={label} className={className}>
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            {sortedSites.length !== 0 ? (
              <tbody className="text-light-black">
                {sortedSites.map((site, ind) => {
                  return (
                    <>
                      <tr
                        key={ind}
                        className="bg-white hover:bg-gray-50 border-b [&_td]:p-3"
                      >
                        <td>{site.id}</td>
                        <td>{site.name}</td>
                        <td>{checkValue(site.machineID)}</td>
                        <td>{checkValue(site.je?.subDivision?.name)}</td>
                        <td>
                          {site.isAutomation ? (
                            <Check
                              color="green"
                              className="mx-auto"
                              strokeWidth={2.5}
                            />
                          ) : (
                            <X
                              color="red"
                              className="mx-auto"
                              strokeWidth={2.5}
                            />
                          )}
                        </td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            ) : (
              <NoDataDisplay />
            )}
          </table>
        </div>
      </div>
    </div>
  );
};
